import React, { useEffect, useReducer } from "react";
import {
  CartesianGrid,
  Legend,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  YAxis,
  ZAxis,
} from "recharts";
import LoadingBox from "../components/LoadingBox";
import useAxios from "../hooks/useAxios";
import { getError } from "../utils";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload.data,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const ScatterChartForOrderItems = ({ startLineNum, endLineNum }) => {
  const axios = useAxios();

  const [{ loading, error, data }, dispatch] = useReducer(reducer, {
    loading: false,
    error: "",
    data: [],
  });

  const preprocessData = (rawData) => {
    return rawData.map((item) => {
      // Convert Date field to timestamp (milliseconds since epoch)
      const xAsTimestamp = new Date(item.x).getTime();
      return { ...item, x: xAsTimestamp };
    });
  };

  const fetchOrderItemsData = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST", payload: {} });
      const { data } = await axios.get(
        `/api/orders/scatter-items?startLineNum=${startLineNum}&endLineNum=${endLineNum}`
      );
      const processedData = preprocessData(data);
      dispatch({ type: "FETCH_SUCCESS", payload: { data: processedData } });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: getError(err) });
    }
  };

  useEffect(() => {
    fetchOrderItemsData();
  }, [startLineNum, endLineNum]);

  return loading ? (
    <LoadingBox>Grafik Yükleniyor!</LoadingBox>
  ) : (
    <ScatterChart
      width={600}
      height={400}
      margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
    >
      <CartesianGrid />
      <XAxis
        type="number"
        dataKey="x"
        name="Saat"
        tickFormatter={(tick) => {
          const date = new Date(tick); // Convert timestamp back to Date
          return date.toLocaleTimeString("tr-TR", {
            hour: "2-digit",
            minute: "2-digit",
          });
        }}
        domain={["auto", "auto"]} // Automatically adjust domain based on data
      />
      <YAxis type="number" dataKey="y" name="Tutar" unit="TL" />
      <ZAxis
        type="number"
        dataKey="z" // Z value to control the size of scatter points
        name="Adet"
        range={[50, 200]} // Adjust the range of point sizes
      />
      <Tooltip
        cursor={{ strokeDasharray: "3 3" }}
        formatter={(value, name) => {
          if (name === "Saat") {
            const date = new Date(value); // Convert timestamp back to Date
            return date.toLocaleTimeString("tr-TR", {
              hour: "2-digit",
              minute: "2-digit",
            });
          }
          return value;
        }}
      />
      <Legend />
      <Scatter
        name="Masalardan Gelen İsteklerin Yoğunluk Grafiği"
        data={data}
        fill="#8884d8"
      />
    </ScatterChart>
  );
};

export default ScatterChartForOrderItems;
